import React from "react";
import { CheckCircle } from "lucide-react";
import { AppCard } from "../../components/ui";

interface MoneyTransferSuccessDialogProps {
    transactionId: string;
    message?: string;
}

const MoneyTransferSuccessDialog: React.FC<MoneyTransferSuccessDialogProps> = ({
    transactionId,
    message = "Your money is on the way.",
}) => {
    // toast: Toast | null = null;
    return (
        <div>
            <AppCard>
                <AppCard.Body
                    className="d-flex flex-column align-items-center justify-content-center text-center min-h-[300px]"
                >
                    <CheckCircle
                        size={80}
                        strokeWidth={1.5}
                        className="text-success mb-4"
                    />

                    <h3 className="text-lg font-semibold text-neutral-900 dark:text-neutral-100 mt-4">
                        <div className="flex items-center justify-center gap-2.5 flex-wrap">
                            <span className="font-bold">Transaction Id:</span>
                            <span className="break-words">{transactionId}</span>
                        </div>
                    </h3>

                    <div className="text-lg">
                        {message}
                    </div>
                </AppCard.Body>
            </AppCard>
            {/* <Toast ref={(el) => (this.toast = el)} position={"bottom-center"} baseZIndex={99999}></Toast> */}
        </div>
    );
};

export default MoneyTransferSuccessDialog;
